// Keep same-page story links usable inside Dawn's focus-trapped mobile drawer.
if (!window.maisonCelesteNavigationLoaded) {
  window.maisonCelesteNavigationLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest?.('.mc-mobile-support a');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const target = document.getElementById(url.hash.slice(1));
    const drawer = link.closest('header-drawer');
    if (!target || !drawer?.closeMenuDrawer) return;
    event.preventDefault();
    drawer.closeMenuDrawer(event);
    drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
    history.pushState(null, '', url.hash);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
}
